/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useEditContextNodeId} from "../../../Hooks/PermissionHooks";

export const QuickLinkListItem = props => {
	const {
		item,
		className = 'unordered',
	} = props;
	
	return <ul key={item?.contextNodeQuickLinkId} className=" unordered-list">
		<li className={className}>
			<a className="link-primary" href={item?.url} target="_blank">{item?.title}</a>
		</li>
	</ul>
}
